import React, { useState } from "react";
import { BsCaretLeftFill, BsCaretRightFill } from "react-icons/bs";
import { getLastTouched, saveLastTouched } from "../../../Logic/LastTouched/misc";
import "./styles.scss";
interface PaginationProps {
    numberofItems: number;
    gridName: string;
    changePage: () => void;
}

interface PaginationState {
    currentPage: number;
    itemsPerPage: number;
    totalPages: number;
    hasDecimals: boolean;
    fromNumber: number;
    toNumber: number;
}

const Pagination: React.FC<PaginationProps> = ({ numberofItems, gridName, changePage }) => {
    let lastTouched = getLastTouched();
    const [paginationState, setPaginationState] = useState<PaginationState>({
        currentPage: 1,
        itemsPerPage: process.env.REACT_APP_ITEMS_PER_PAGE ? parseInt(process.env.REACT_APP_ITEMS_PER_PAGE) : 1000,
        totalPages: 0,
        hasDecimals: false,
        fromNumber: 1,
        toNumber: 15,
    });

    React.useEffect(() => {
        const totalPages = Math.ceil(numberofItems / paginationState.itemsPerPage);
        const hasDecimals = numberofItems % paginationState.itemsPerPage !== 0;
        const toNumber = Math.min(paginationState.currentPage * paginationState.itemsPerPage, numberofItems);
        setPaginationState(prevState => ({
            ...prevState,
            totalPages,
            hasDecimals,
            toNumber,
        }));
    }, [numberofItems, paginationState.itemsPerPage]);

    React.useEffect(() => {
        if (gridName == "mailbox") {
            setPaginationState(prevState => ({
                ...prevState,
                currentPage: lastTouched.Queue.Pagination.pageNumber,
            }));
        }
    }, [JSON.stringify(lastTouched)]);

    const handleChange = (event: { target: { value: string } }) => {
        handlePageChange(parseInt(event.target.value));
    };
    const handlePageChange = (pageNumbmer: number) => {
        setPaginationState(prevState => ({
            ...prevState,
            currentPage: pageNumbmer,
            fromNumber: (pageNumbmer - 1) * prevState.itemsPerPage + 1,
            toNumber: Math.min(pageNumbmer * prevState.itemsPerPage, numberofItems),
        }));
        const iLastTouched = getLastTouched();
        if (gridName == "mailbox") {
            iLastTouched.Queue.Pagination.pageNumber = pageNumbmer;
        }
        saveLastTouched(iLastTouched);
        changePage();
    };

    return (
        <div className="paginationContainer">
            <div className="pageCol">
                <table
                    cellPadding={0}
                    cellSpacing={0}
                >
                    <tr>
                        <td
                            title="Go To First Page"
                            style={{ paddingRight: "5px" }}
                            onClick={() => {
                                handlePageChange(1);
                            }}
                            className={paginationState.currentPage === 1 ? "disablePagination" : "paginationIcon"}
                        >
                            |<BsCaretLeftFill />
                        </td>
                        <td
                            title="Previous Page"
                            style={{ paddingRight: "5px" }}
                            onClick={() => {
                                handlePageChange(paginationState.currentPage - 1);
                            }}
                            className={paginationState.currentPage === 1 ? "disablePagination" : "paginationIcon"}
                        >
                            <BsCaretLeftFill />
                        </td>

                        <td style={{ paddingRight: "5px" }}>
                            <select
                                className="g-Select-default"
                                style={{ height: "20px" }}
                                value={paginationState.currentPage}
                                onChange={handleChange}
                            >
                                {[...Array(paginationState.totalPages)].map((_, index) => (
                                    <option
                                        key={index}
                                        value={index + 1}
                                    >
                                        page {index + 1}
                                    </option>
                                ))}
                            </select>
                        </td>
                        <td
                            title="Next Page"
                            style={{ paddingRight: "5px" }}
                            onClick={() => {
                                handlePageChange(paginationState.currentPage + 1);
                            }}
                            className={
                                paginationState.currentPage === paginationState.totalPages
                                    ? "disablePagination"
                                    : "paginationIcon"
                            }
                        >
                            <BsCaretRightFill />
                        </td>
                        <td
                            title="Go To Last Page"
                            onClick={() => {
                                handlePageChange(paginationState.totalPages);
                            }}
                            className={
                                paginationState.currentPage === paginationState.totalPages
                                    ? "disablePagination"
                                    : "paginationIcon"
                            }
                        >
                            <BsCaretRightFill />|
                        </td>
                    </tr>
                </table>
            </div>
            <div className="viewsCol">
                {" "}
                Viewing {paginationState.fromNumber} - {paginationState.toNumber} of {numberofItems}{" "}
            </div>
        </div>
    );
};

export default Pagination;
